import { render, staticRenderFns } from "./treatment_record.vue?vue&type=template&id=d1437ff6&"
import script from "./treatment_record.vue?vue&type=script&lang=js&"
export * from "./treatment_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports